// 资产
import tool from '@/views/qianchuan/assets'
export default {
  path: '/qianchuan/assets',
  name: 'assets',
  component: tool,
  meta: {
    keepAlive: true,
    title: '资产',
    // code: 'page:report',
    activeName: '/assets',
    permission: 'property',
    name: 'material'
  },
  children: [
    {
      path: 'material',
      name: 'material',
      component: resolve => require(['@/views/qianchuan/assets/material'], resolve),
      meta: {
        keepAlive: true,
        title: '创意素材',
        iconName: 'icon-material',
        permission: 'creativity:image',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'material-li',
          title: '素材库'

        },
        {
          name: 'title',
          title: '标题库'
        },
        {
          name: 'qccreativeComponents',
          title: '创意组件'
        }
      ],
      children: [
        {
          path: 'material-li',
          name: 'material-li',
          component: resolve => require(['@/views/material/materialLibrary'], resolve),
          meta: {
            keepAlive: true,
            title: '素材库',
            iconName: 'icon-material',
            permission: 'image'
          }
        },
        {
          path: 'title',
          name: 'title',
          component: resolve => require(['@/views/material/titleLibrary'], resolve),
          meta: {
            keepAlive: true,
            title: '标题库',
            iconName: 'icon-title',
            permission: 'title'
          }
        },
        {
          path: 'qccreativeComponents',
          name: 'qccreativeComponents',
          component: resolve => require(['@/views/qianchuan/putin/creativeComponents'], resolve),
          meta: {
            keepAlive: true,
            title: '创意组件',
            iconName: 'icon-chuangyizujian-copy',
            permission: 'keywords'
          }
        }
      ]
    },
    {
      path: 'directional',
      name: 'directional',
      component: resolve => require(['@/views/putin/directional'], resolve),
      meta: {
        keepAlive: true,
        title: '定向',
        iconName: 'icon-dingxiangguanli',
        permission: 'directional',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'qcdirectional',
          title: '定向包'

        },
        {
          name: 'qccrowd',
          title: '人群包'
        }
      ],
      children: [
        {
          path: 'qcdirectional',
          name: 'qcdirectional',
          component: resolve => require(['@/views/qianchuan/putin/directional'], resolve),
          meta: {
            keepAlive: true,
            title: '定向包',
            iconName: 'icon-dingxiangguanli',
            permission: 'directional'
          },
          children: [
            {
              path: 'addBaseDirectional',
              name: 'qcaddBaseDirectional',
              component: resolve => require(['@/views/qianchuan/putin/directional/addBaseDirectional'], resolve),
              meta: {
                keepAlive: true,
                title: '新建基础定向包'
              }
            },
            {
              path: 'addReleasedDirectional',
              name: 'qcaddReleasedDirectional',
              component: resolve => require(['@/views/qianchuan/putin/directional/addReleasedDirectional'], resolve),
              meta: {
                keepAlive: true,
                title: '新建投放定向包'
              }
            },
            {
              path: 'addDirectional',
              name: 'qcaddDirectional',
              component: resolve => require(['@/views/qianchuan/putin/directional/addDirectional'], resolve),
              meta: {
                keepAlive: true,
                title: '新建定向包'
              }
            }
          ]
        },
        {
          path: 'crowd',
          name: 'qccrowd',
          component: resolve => require(['@/views/qianchuan/putin/crowd'], resolve),
          meta: {
            keepAlive: true,
            title: '人群管理',
            iconName: 'icon-renqunguanli',
            permission: 'crowd'
          }
        },
        {
          path: 'qccrowd',
          name: 'qccrowd',
          component: resolve => require(['@/views/qianchuan/putin/crowd'], resolve),
          meta: {
            keepAlive: true,
            title: '人群包',
            iconName: 'icon-renqunguanli',
            permission: 'crowd'
          }
        }
      ]

    },
    {
      path: 'channel',
      name: 'qcchannel',
      component: resolve => require(['@/views/qianchuan/putin/channel'], resolve),
      meta: {
        keepAlive: true,
        title: '商品/抖音号',
        iconName: 'icon-qudaoguanli',
        permission: 'keywords'
      }
    },
    {
      path: 'label',
      name: 'qclabel',
      component: resolve => require(['@/views/qianchuan/putin/label'], resolve),
      meta: {
        keepAlive: true,
        title: '标签包',
        iconName: 'icon-biaoqianbao',
        permission: 'adTask'
      }
    },
    {
      path: 'filterwords',
      name: 'qcfilterwords',
      component: resolve => require(['@/views/material/filterwordsLibrary'], resolve),
      meta: {
        keepAlive: true,
        title: '屏蔽词库',
        iconName: 'icon-cidian',
        permission: 'blackWord'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/qianchuan/assets.js